var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _c("div", { staticClass: "dashboard-results-details" }, [
          _c(
            "div",
            { staticClass: "w-full flex flex-wrap justify-between spacer-b-2" },
            [
              _c("div", { staticClass: "count" }, [
                _c("span", [_vm._v(_vm._s(_vm.pagination.total))]),
                _vm._v(" Pending " + _vm._s(_vm.$t("Requests"))),
              ]),
              _vm._v(" "),
              _c("booking-list-sort", {
                attrs: {
                  "set-filter-mutation": _vm.setFilter,
                  filters: _vm.filters,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "booking-list-filters",
          {
            attrs: {
              "set-filter-mutation": _vm.setFilter,
              filters: _vm.filters,
              "apply-filters": _vm.handleApplyFiltersCallback,
            },
          },
          [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-primary pull-right",
                attrs: {
                  slot: "button",
                  click: _vm.handleApplyFiltersCallback,
                  type: "submit",
                },
                slot: "button",
              },
              [_vm._v("\n        Search\n      ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dashboard-block" },
          [
            _c(
              "ul",
              { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
              [
                _c(
                  "li",
                  { class: { active: _vm.status === "vetting" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            params: { status: "vetting" },
                            query: _vm.$route.query,
                          },
                        },
                      },
                      [_vm._v("Vetting")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { class: { active: _vm.status === "draft" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            params: { status: "draft" },
                            query: _vm.$route.query,
                          },
                        },
                      },
                      [_vm._v("Drafts")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { class: { active: _vm.status === "archived" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            params: { status: "archived" },
                            query: _vm.$route.query,
                          },
                        },
                      },
                      [_vm._v("Archived Drafts")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm.fetchingVettingBookingRequests
              ? _c("pickstar-loading", { staticClass: "m-t-lg" })
              : [
                  _vm.haveNoVettingBookingRequests
                    ? _c("no-results", [
                        _c("div", [_vm._v("There are no pending requests.")]),
                        _vm._v(" "),
                        _vm.haveAppliedFilters
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-default btn-sm m-t-sm",
                                on: { click: _vm.handleResetFiltersCallback },
                              },
                              [_vm._v("Reset Filters")]
                            )
                          : _vm._e(),
                      ])
                    : _c(
                        "ul",
                        { staticClass: "list-items" },
                        _vm._l(_vm.requests, function (booking) {
                          return _c("vetting-list-item", {
                            key: booking.id,
                            attrs: { booking: booking },
                          })
                        }),
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "lazy-loading",
                    {
                      ref: "lazyLoading",
                      staticClass: "text-center",
                      attrs: {
                        loading: _vm.loading,
                        "reached-bottom":
                          _vm.handleGetNextVettingBookingRequestsCallback,
                      },
                    },
                    [
                      _c("pickstar-loading", {
                        attrs: { slot: "loading" },
                        slot: "loading",
                      }),
                      _vm._v(" "),
                      _c("span", {
                        attrs: { slot: "finished" },
                        slot: "finished",
                      }),
                    ],
                    1
                  ),
                ],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Pending Approval")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }